import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { Autocomplete, Dropdown } from '@components/Autocomplete'
import FilterGroup from '@components/FilterGroup'
import { DatePickerRange } from '@components/DatePicker'
import { StatusFilter } from '@components/StatusFilter'
import { SearchPanelContainer } from '@components/Search'

class SearchPanel extends Component {
  onRefresh = () => {
    this.props.contractSearchStore.resetFilter()
  }

  render () {
    const { contractSearchStore, atheneumOfficeStore, modalStore } = this.props
    const { contractTypes, query } = contractSearchStore

    const MUNICH = 10 // considered same as Berlin, agreed to be excluded
    const atheneumOffices = [
      { id: 0, entityName: 'All' },
      ...atheneumOfficeStore.atheneumOffices
    ].filter(office => office.id !== MUNICH)

    return (
      <SearchPanelContainer
        wide
        buttonProps={{
          buttonText: 'Create new contract',
          onClick: () =>
            modalStore.show({
              type: 'CONTRACT_FORM',
              props: {
                contractSearchStore,
                title: `Create contract`,
                okText: 'Save',
                cancelText: 'Cancel'
              }
            }),
          roles: ['AdvancedReporting', 'Admin']
        }}
        searchTitle='Filter Contracts'
        onClearSearch={this.onRefresh}
      >
        <FilterGroup label='Contract created date range'>
          <DatePickerRange
            onFromChange={contractSearchStore.changeFromDate}
            onToChange={contractSearchStore.changeToDate}
            fromDate={query.fromDate}
            toDate={query.toDate}
          />
        </FilterGroup>
        <FilterGroup label='Parent account'>
          <Autocomplete
            value={query.parentAccount}
            itemToString={item => item && item.parentAccountName}
            onChange={contractSearchStore.changeParentAccount}
            loadOptions={contractSearchStore.parentAccountAutocomplete}
          />
        </FilterGroup>
        <FilterGroup label='Account'>
          <Autocomplete
            value={query.account}
            itemToString={item => item && item.companyName}
            onChange={contractSearchStore.changeAccount}
            loadOptions={contractSearchStore.accountAutocomplete}
          />
        </FilterGroup>
        <FilterGroup label='Atheneum contract party'>
          <Dropdown
            valueIsId
            itemToString={item => item && item.entityName}
            options={atheneumOffices}
            selectedItem={query.atheneumOfficeId}
            onChange={office => {
              contractSearchStore.changeAtheneumContractParty(office.id)
            }}
          />
        </FilterGroup>
        <FilterGroup label='Signed by'>
          <Autocomplete
            value={query.employee}
            itemToString={item => item && item.fullName}
            onChange={contractSearchStore.changeEmployee}
            loadOptions={contractSearchStore.employeeAutocomplete}
          />
        </FilterGroup>
        <FilterGroup label='Contract code'>
          <input
            className='contracts-code-input'
            onChange={e => {
              contractSearchStore.changeContractCode(e.target.value)
            }}
            value={query.searchString}
          />
        </FilterGroup>
        <FilterGroup label='Contract type'>
          <Dropdown
            valueIsId
            itemToString={item => item && item.name}
            options={[{ id: 0, name: 'All' }].concat(contractTypes)}
            selectedItem={query.contractTypeId}
            onChange={type => {
              contractSearchStore.changeContractType(type.id)
            }}
          />
        </FilterGroup>
        <FilterGroup label='Contract status'>
          <StatusFilter
            type='contract'
            selectedItems={query.contractStatuses}
            onChange={contractSearchStore.changeContractStatus}
          />
        </FilterGroup>
      </SearchPanelContainer>
    )
  }

  static propTypes = {
    contractSearchStore: PropTypes.object,
    atheneumOfficeStore: PropTypes.object,
    modalStore: PropTypes.object
  }
}

export default inject(
  'modalStore',
  'atheneumOfficeStore'
)(observer(SearchPanel))
